export default __webpack_public_path__ + "static/3-4--409a5cec38ef99cadeaf222c838c649d.png";